import { render, staticRenderFns } from "./ProductFileConfig.vue?vue&type=template&id=c00c8c32&scoped=true&"
import script from "./ProductFileConfig.vue?vue&type=script&lang=js&"
export * from "./ProductFileConfig.vue?vue&type=script&lang=js&"
import style0 from "./ProductFileConfig.vue?vue&type=style&index=0&id=c00c8c32&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c00c8c32",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCol,VRow,VSelect,VTextField})


/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/aims-dashboard/aims-dashboard/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c00c8c32')) {
      api.createRecord('c00c8c32', component.options)
    } else {
      api.reload('c00c8c32', component.options)
    }
    module.hot.accept("./ProductFileConfig.vue?vue&type=template&id=c00c8c32&scoped=true&", function () {
      api.rerender('c00c8c32', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/System/ProductFileConfig.vue"
export default component.exports